// // src/components/AccountCreation/Step1_SubscriptionPlan.js
// import React from 'react';
// import { PLANS_CONFIG, PLAN_FEATURES } from './constants';

// const Step1_SubscriptionPlan = ({ data, setData, nextStep, apiData, setApiParams, apiParams, apiLoading }) => {
//     const { planId, frequency, price, tierName } = data.subscription;
//     const activationFee = data && data.products.find(p => p.productType === 'ACTIVATION_FEE');
//     const totalPrice = (price || 0) + (activationFee?.finalPrice || 0);

//     const cleanTierName = (name) => {
//         if (!name) return '';
//         return name.replace('Acuma', '').replace('SUBS_', '');
//         //return name;
//     }

//     const currentTier = apiData?.subscriptions?.[0]?.tiers.find(t => t.tierName === tierName);

//     const availablePlansForDevice = currentTier?.plans.filter(p => p.deviceTypeId === apiParams.device_type) || [];

//     // Create a unique list of plans to prevent duplicates in the dropdown
//     const uniquePlans = Array.from(new Map(availablePlansForDevice.map(plan => [plan.id, plan])).values());

//     const handleSelectionChange = (field, value) => {
//         if (field === 'region_code' || field === 'device_type') {
//             setApiParams(prev => ({ ...prev, [field]: value }));
//             return;
//         }

//         if (field === 'tierName') {
//             const selectedTier = apiData?.subscriptions?.[0]?.tiers.find(t => t.tierName === value);
//             const firstPlanInTier = selectedTier?.plans.find(p => p.deviceTypeId === apiParams.device_type);

//             if (firstPlanInTier) {
//                 setData(prev => ({
//                     ...prev, subscription: {
//                         ...prev.subscription,
//                         tierName: value,
//                         planId: firstPlanInTier.id,
//                         planName: firstPlanInTier.planName,
//                         frequency: firstPlanInTier.paymentFrequency.frequency,
//                         price: firstPlanInTier.finalPrice,
//                         tierPlanCode: firstPlanInTier.code
//                     }
//                 }));
//             }
//         }

//         if (field === 'planId') {
//             const selectedPlanId = parseInt(value, 10);
//             const selectedPlan = uniquePlans.find(p => p.id === selectedPlanId);
//             if (selectedPlan) {
//                 setData(prev => ({
//                     ...prev, subscription: {
//                         ...prev.subscription,
//                         planId: selectedPlan.id,
//                         planName: selectedPlan.planName,
//                         frequency: selectedPlan.paymentFrequency.frequency,
//                         price: selectedPlan.finalPrice,
//                         tierPlanCode: selectedPlan.code
//                     }
//                 }));
//             }
//         }
//     };

//     const PlanFeatureCard = ({ selectedPlan }) => {
//         const cleanedName = cleanTierName(selectedPlan);
//         console.log("cleanedName...", cleanedName)
//         console.log("PLAN_FEATURES...", PLAN_FEATURES[cleanedName])

//         if (!cleanedName || !PLAN_FEATURES[cleanedName]) {
//             return (
//                 <div className="plan-feature-card placeholder-card">
//                     <div className="card-body text-center d-flex align-items-center justify-content-center">
//                         <p className="text-muted">Select a plan to see its features.</p>
//                     </div>
//                 </div>
//             );
//         }
//         return (
//             <div className={`plan-feature-card plan-${cleanedName.toLowerCase()}`}>
//                 <div className="card-header"><h3 className="fw-bold h4">{cleanedName}</h3></div>
//                 <div className="card-body">
//                     <ul className="list-unstyled feature-list">
//                         {PLAN_FEATURES[cleanedName].map((feature, i) => (
//                             <li key={i}><i className="bi bi-check-circle-fill me-2"></i>{feature}</li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="step-content">
//             <h2 className="step-title text-center">Select Your Plan</h2>
//             <p className="step-subtitle text-center">Choose the subscription that best fits your needs.</p>
//             <div className="row g-4">
//                 <div className="col-lg-6">
//                     <div className="row g-3">
//                         <div className="col-12"><label htmlFor="region" className="form-label">Region</label><select id="region" className="form-select" value={apiParams.region_code} onChange={(e) => handleSelectionChange('region_code', e.target.value)}><option value="us_ca">US/Canada</option><option value="intl">International</option></select></div>
//                         <div className="col-12"><label htmlFor="deviceType" className="form-label">Device Type</label><select id="deviceType" className="form-select" value={apiParams.device_type} onChange={(e) => handleSelectionChange('device_type', parseInt(e.target.value, 10))}><option value={1}>iOS</option><option value={2}>Android</option></select></div>
//                         {/* <hr className="my-4" /> */}
//                         {apiLoading ? <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading Plans...</span></div></div> : <>
//                             <div className="col-12"><label htmlFor="plan" className="form-label">Plan</label><select id="plan" className="form-select" value={tierName} onChange={(e) => handleSelectionChange('tierName', e.target.value)} disabled={!apiData}>{apiData?.subscriptions?.[0]?.tiers.map(t => <option key={t.id} value={t.tierName}>{cleanTierName(t.tierName)}</option>)}</select></div>
//                             <div className="col-12"><label htmlFor="billingPlan" className="form-label">Billing Plan</label><select id="billingPlan" className="form-select" value={planId} onChange={(e) => handleSelectionChange('planId', e.target.value)} disabled={!currentTier}>{uniquePlans.map(p => <option key={p.id} value={p.id}>{p.paymentFrequency.frequency}</option>)}</select></div>
//                         </>}
//                     </div>
//                     <div className="price-display">
//                         <div className="d-flex justify-content-between mb-2"><span>Subscription</span> <strong>${price.toFixed(2)}</strong></div>
//                         {activationFee && <div className="d-flex justify-content-between"><span>Activation Fee</span> <strong>${activationFee.finalPrice.toFixed(2)}</strong></div>}
//                         <hr />
//                         <div className="d-flex justify-content-between fw-bold h5"><span>Total Due Today</span> <span>${totalPrice.toFixed(2)}</span></div>
//                     </div>
//                     {activationFee && <p className="text-muted small text-center mt-2">All plans include a one-time <strong>${activationFee.finalPrice.toFixed(2)} activation fee</strong> which is included in the total first payment shown above.</p>}
//                 </div>
//                 <div className="col-lg-6">
//                     <PlanFeatureCard selectedPlan={tierName} />
//                 </div>
//             </div>
//             <div className="text-end mt-4">
//                 <button onClick={nextStep} className="btn btn-primary" disabled={!planId || apiLoading}>Next</button>
//             </div>
//         </div>
//     );
// };

// export default Step1_SubscriptionPlan;

// src/components/AccountCreation/Step1_SubscriptionPlan.js
// src/components/AccountCreation/Step1_SubscriptionPlan.js

// src/components/AccountCreation/Step1_SubscriptionPlan.js
import React, { useEffect, useState } from 'react';
import { PLAN_FEATURES } from './constants';

const Step1_SubscriptionPlan = ({ data, setData, nextStep, apiData, setApiParams, apiParams, apiLoading, apiError, prevStep }) => {
    const { planId, frequency, price, tierName } = data.subscription;
    const activationFee = data && data.products.find(p => p.productType === 'ACTIVATION_FEE');
    const totalPrice = (price || 0) + (activationFee?.finalPrice || 0);

    // New state to track the globally selected display frequency for comparison
    const [displayFrequency, setDisplayFrequency] = useState(frequency || 'MONTHLY');

    useEffect(() => {
        // Ensure the display frequency is initialized from the form data
        if (frequency) {
            setDisplayFrequency(frequency);
        }
    }, [frequency]);


    const handleApiParamsChange = (field, value) => {
        setApiParams(prev => ({ ...prev, [field]: value }));
    };

    const handlePlanSelection = (tier, plan) => {
        // Set the main form data for the selected plan
        setData(prev => ({
            ...prev,
            subscription: {
                ...prev.subscription,
                tierName: tier.tierName,
                planId: plan.id,
                planName: plan.planName,
                frequency: plan.paymentFrequency.frequency,
                price: plan.finalPrice,
                tierPlanCode: plan.code
            }
        }));
        // Update the global display frequency to sync other cards
        setDisplayFrequency(plan.paymentFrequency.frequency);
    };

    const PlanCard = ({ tier, currentDisplayFrequency }) => {
        const cleanTierName = (name) => name ? name.replace('Acuma', '').replace('SUBS_', '').replace('Intl', '') : '';
        const name = cleanTierName(tier.tierName);

        const devicePlans = tier.plans.filter(p => p.deviceTypeId === apiParams.device_type);
        const frequencies = [...new Set(devicePlans.map(p => p.paymentFrequency.frequency))].sort((a, b) => {
            const order = ['MONTHLY', 'QUARTERLY', 'SEMI ANNUALLY', 'ANNUALLY', 'ONE TIME PURCHASE'];
            return order.indexOf(a) - order.indexOf(b);
        });

        const isSelectedTier = tierName === tier.tierName;

        // Determine which plan to show based on the global display frequency
        // Fallback to the first plan if the tier doesn't have the selected frequency
        const planToShow = devicePlans.find(p => p.paymentFrequency.frequency === currentDisplayFrequency) || devicePlans[0];

        if (!planToShow) return null;

        const cardClass = `plan-feature-card plan-${name.toLowerCase()} ${isSelectedTier ? 'selected' : ''}`;

        const getIntervalUnit = (freq) => {
            switch (freq) {
                case 'MONTHLY': return '/month';
                case 'QUARTERLY': return '/3months';
                case 'SEMI ANNUALLY': return '/6months';
                case 'ANNUALLY': return '/year';
                case 'ONE TIME PURCHASE': return '/one-time';
                default: return '';
            }
        };

        return (
            <div className="col">
                <div className={cardClass} onClick={() => handlePlanSelection(tier, planToShow)}>
                    {isSelectedTier && <div className="selected-tick"><i className="bi bi-check-circle-fill"></i></div>}
                    <div className="card-header">
                        <h3 className="fw-bold h4">{name}</h3>
                    </div>
                    <div className="card-body">
                        <div className="frequency-toggle btn-group btn-group-sm d-flex my-3" role="group">
                            {frequencies.map(freq => {
                                const planForFreq = devicePlans.find(p => p.paymentFrequency.frequency === freq);
                                if (!planForFreq) return null;
                                const label = freq.replace(' ANNUALLY', '').replace(' PURCHASE', '');
                                return (
                                    <button
                                        key={freq}
                                        type="button"
                                        className={`btn flex-grow-1 text-capitalize ${currentDisplayFrequency === freq ? 'btn-primary active' : 'btn-light'}`}
                                        onClick={(e) => { e.stopPropagation(); handlePlanSelection(tier, planForFreq); }}>
                                        {label.toLowerCase()}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="price text-center my-3">
                            <span className="h2 fw-bolder" style={{ color: "#202529f7" }}>${planToShow.finalPrice.toFixed(2)}</span>
                            <span className="text-muted small">{getIntervalUnit(planToShow.paymentFrequency.frequency)}</span>
                        </div>
                        <ul className="list-unstyled feature-list mt-auto text-start">
                            {PLAN_FEATURES[name]?.map((feature, i) => (
                                <li key={i}>
                                    <span><i className="bi bi-check me-2"></i></span>
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="step-content">
            <h2 className="step-title text-center">Select Your Plan</h2>
            <p className="step-subtitle text-center">Choose the subscription that best fits your needs.</p>

            {/* <div className="row justify-content-center g-3 mb-4">
                <div className="col-auto">
                    <div className="btn-group">
                        <button className={`btn btn-outline-primary ${apiParams.region_code === 'us_ca' ? 'active' : ''}`} onClick={() => handleApiParamsChange('region_code', 'us_ca')}>US/Canada</button>
                        <button className={`btn btn-outline-primary ${apiParams.region_code === 'uk' ? 'active' : ''}`} onClick={() => handleApiParamsChange('region_code', 'uk')}>UK</button>
                        <button className={`btn btn-outline-primary ${apiParams.region_code === 'intl' ? 'active' : ''}`} onClick={() => handleApiParamsChange('region_code', 'intl')}>International</button>
                    </div>
                </div>
                <div className="col-auto">
                    <div className="btn-group">
                        <button className={`btn btn-outline-primary ${apiParams.device_type === 2 ? 'active' : ''}`} onClick={() => handleApiParamsChange('device_type', 2)}>Android</button>
                        <button className={`btn btn-outline-primary ${apiParams.device_type === 1 ? 'active' : ''}`} onClick={() => handleApiParamsChange('device_type', 1)}>iOS</button>
                    </div>
                </div>
            </div> */}

            {apiParams.region_code === 'uk' && (
                <div className="uk-redirect-link text-center mb-4">
                    <p className="mb-0">For purchases in the UK, please visit our <a href="https://epilepsysolutions.co.uk/" target="_blank" rel="noopener noreferrer">UK Store</a>.</p>
                </div>
            )}

            {apiParams.region_code !== 'uk' ? apiLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading Plans...</span>
                    </div>
                </div>
            ) : (
                <div className="row g-4 justify-content-center">
                    {apiData?.subscriptions?.[0]?.tiers.map(tier => <PlanCard key={tier.id} tier={tier} currentDisplayFrequency={displayFrequency} />)}
                </div>
            ) : <></>}

            {apiParams.region_code !== 'uk' && apiError && <div className="text-danger" style={{ textAlign: "center", fontSize: "16px", marginTop: "2rem" }}>{apiError}</div>}
            {apiParams.region_code !== 'uk' && activationFee && (
                <p className="text-muted activation-fee-class text-center mt-3">
                    All plans include a one-time <strong>${activationFee.finalPrice.toFixed(2)} activation fee</strong> which will be added to your first payment.
                </p>
            )}

            <div className="d-grid gap-2 d-md-flex justify-content-md-between mt-4">
                <button onClick={prevStep} className="btn btn-outline-primary">BACK</button>
                <button onClick={nextStep} className="btn btn-primary" disabled={!planId || apiLoading || apiParams.region_code === 'uk'}>CONTINUE</button>
            </div>
        </div>
    );
};

export default Step1_SubscriptionPlan;




